import styled from "styled-components";

export const StyledPublicQuestionForm = styled.div`
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  direction: rtl;
  box-sizing: border-box;
  padding-bottom: 40px;

  .public-form-header {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px 25px;
    box-shadow: 0px 4px 9.3px 0px #7e8aad4a;
    margin-bottom: 30px;
  }

  .public-form-logo {
    height: 48px;
    object-fit: contain;
  }

  .form-content-wrapper {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .question-box-wrapper {
    width: 100%;
    margin-bottom: 32px;
  }

  .answer-textarea {
    width: 100%;
    min-height: 80px;
    padding: 0;
    border: none;
    background: transparent;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.22px;
    line-height: 1.5;
    text-align: center;
    color: #122243;
    resize: none;
    box-sizing: border-box;

    &::placeholder {
      color: #7e8aad;
      opacity: 0.8;
    }

    &:focus {
      outline: none;
      /* removed box-shadow to match the borderless look */
    }
  }

  .send-button {
    width: 129px;
    height: 30px;
    border: none;
    border-radius: 24px;
    background: #004EF7;
    color: white;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 25px;
    transition:
      opacity 0.2s,
      transform 0.2s;

    &:hover:not(:disabled) {
      opacity: 0.95;
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .send-icon {
    display: block;
  }

  .footer-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 330px;
  }

  .footer-illustration {
    width: 326px;
    height: 217px;
    margin-bottom: 24px;
    object-fit: contain;
  }

  .footer-text {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.22px;
    color: #122243;
    text-align: center;
    line-height: 1.4;
    margin: 0 0 16px 0;
  }

  .footer-cta-button {
    width: 129px;
    height: 30px;
    border: none;
    border-radius: 20px;
    text-decoration: none;
    background: #00eeb0;
    color: #122243;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.22px;
    cursor: pointer;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      opacity: 0.9;
    }
  }

  .success-box {
    width: 100%;
    height: 160px;
    background: linear-gradient(271.58deg, #004EF7 0.01%, #00EAB2 96.51%);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 28px;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  }

  .success-box-text {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: -0.22px;
    text-align: center;
    color: #ffffff;
    margin: 0;
    white-space: pre-wrap;
  }

  .success-reset-button {
    width: 129px;
    height: 30px;
    background: #00eab2;
    border: none;
    border-radius: 20px;
    color: #122243;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.22px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }

  .error-message {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 14px;
    color: #d32f2f;
    margin: 16px 0;
    text-align: center;
  }

  .loading-message {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 15px;
    color: #7e8aad;
    margin: 24px 0;
    text-align: center;
  }

  .not-found-message {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 16px;
    color: #7e8aad;
    margin: 40px 0;
    text-align: center;
  }
`;
